import React from 'react';
import { createRoot } from 'react-dom/client';
import { initI18nFromSSR } from './i18n/initFromSSR';
import ProductQuickView from './features/productquickview/ProductQuickView';
import { ProductQuickViewProps } from './types/Product';

// Initialize i18n promise (only once, shared across renders)
const i18nInitPromise = initI18nFromSSR();

// Export render function for use in main.js
const ProductQuickViewReact = {
  render: (container: HTMLElement, props: ProductQuickViewProps) => {
    // Đợi translations load xong trước khi render
    i18nInitPromise.then(() => {
      const root = createRoot(container);
      root.render(<ProductQuickView {...props} />);
    });
  }
};

// Make it available globally immediately when this module loads
(window as any).ProductQuickViewReact = ProductQuickViewReact;

export default ProductQuickView;